{
  "help": "Help",
  "info": "Informatie"
}
